// extracted by mini-css-extract-plugin
export default {"verificationButton":"PhoneVerificationButton_verificationButton__K3Hgc"};